//Package imports
import styled from 'styled-components'

//Custom component imports
import Header from './components/Header'

export default function App() {
  const Container = styled.div`
    width: 100%;
    margin: 0 auto;

    @media (min-width: 739px) {
      width: 99%;
    }

    @media (min-width: 1025px) {
      width: 960px;
    }

    @media (min-width: 1200px) {
      width: 1160px;
    }

    background: white;
    transition: all linear 20ms;
  `

  return (
    <Container className='hidden-print'>
      <Header />
    </Container>
  )
}
